import React, { Component } from 'react';
import apiClient from '../lib/apiClient';
import { withAuth } from '../providers/AuthProvider';
class Gig extends Component {
	constructor() {
		super();
		this.state = {
			place: "",
			day: "",
			availableSongs: [],
			chosenSongs: [],
			isLoading: true
		}
	}

	async componentDidMount() {
		const availableSongs = await apiClient.getAllSongs();
			return this.setState({ availableSongs, isLoading: false });
	}

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value })
	}

	handleClick = (event) => {
    const { availableSongs } = this.state;
    const newSongsArr = [...availableSongs];
		const id = event.target.value;
		const chosenSong = newSongsArr.filter(song => (song._id === id));
		const index = newSongsArr.indexOf(chosenSong[0]);
		newSongsArr[index].chosen = event.target.checked;
    return this.setState({ availableSongs: newSongsArr });
  }

	handleSubmit = async  (event) => {
		const { place, day, availableSongs, chosenSongs } = this.state;
		event.preventDefault();
		await availableSongs.forEach(song => {
			if (song.chosen) {
				chosenSongs.push(song);
			}
		})
		await apiClient.addGig({ place, day, songs: chosenSongs });
		location.href = "https://max-and-sax.netlify.app/order";
	}

	render() {
		const { place, day, availableSongs, isLoading } = this.state;
		
		if (isLoading) {
			return <div>loading ... </div>;
		}
		
		return <div className="main">
		<div className="flex flex-col items-center py-5 w-80 h-auto min-h-2/3 mx-auto">
			<p className="text-2xl">Afegeix nova actuació</p>
			<form onSubmit={this.handleSubmit}>
				<label>Lloc: </label>
				<br />
				<input className="w-full formInput" type="text" name="place" value={place} onChange={this.handleChange} />
			
				<label>Dia: </label>
				<br />
				<input className="w-full formInput" type="text" name="day" value={day} onChange={this.handleChange} />
			
				<label>Temes: </label>
				<div className="mb-5 mx-auto">
					{availableSongs.map((song, index) => {
						const { artist, name, _id, chosen, pageNum } = song;
					
						return <div key={index}>
							<label>
								<input type="checkbox" checked={chosen} value={_id} onChange={this.handleClick} /> {`${artist} - ${name} - Pàg. ${pageNum}`}
							</label>
							<br />
						</div>
					})
					}
				</div>
				<input type="submit" className="button w-full" value="Genera nova actuació" />
			</form>
		</div>
		</div>
	}
}

export default withAuth(Gig);
